import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose} from "@angular/material/dialog";
import {GalleryComponent} from "@daelmaak/ngx-gallery";
import {NgIf} from "@angular/common";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-dialog-image-popup',
  standalone: true,
  imports: [
    GalleryComponent,
    NgIf,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ],
  templateUrl: './dialog-image-popup.component.html',
  styleUrl: './dialog-image-popup.component.css'
})
export class DialogImagePopupComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { images: any, selectedIndex: number }) {
  }

  ngOnInit(): void {
  }

  onFullScreen(fullScreen: Event) {
    console.log('fullScreen: ', fullScreen)
  }
}
